import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import { AuthLayout } from "@/components/AuthLayout";
import { Field, BigButton } from "@/components/Field";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function Register() {
  const { user, register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  if (user) return <Navigate to="/dashboard" replace />;

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Conta criada com sucesso!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout title="Criar conta de cliente" subtitle="Acompanhe suas fazendas, equipamentos e serviços.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <Field label="Nome completo" id="name" required value={form.name} onChange={set("name")} data-testid="register-name-input" />
        <Field label="E-mail" id="email" type="email" required value={form.email} onChange={set("email")} data-testid="register-email-input" />
        <Field label="Telefone / WhatsApp" id="phone" type="tel" value={form.phone} onChange={set("phone")} data-testid="register-phone-input" />
        <Field label="Senha (mín. 6 caracteres)" id="password" type="password" minLength={6} required value={form.password} onChange={set("password")} data-testid="register-password-input" />
        <BigButton type="submit" disabled={busy} className="mt-2" data-testid="register-submit-button">
          {busy && <Loader2 className="h-5 w-5 animate-spin" />} Criar conta
        </BigButton>
      </form>
      <p className="mt-6 text-center text-[#5C6B66]">
        Já tem conta? <Link to="/login" className="font-semibold text-[#1E4D2B] hover:underline" data-testid="back-to-login-link">Entrar</Link>
      </p>
    </AuthLayout>
  );
}
